import { ApplicationElement, html } from '@beunity/lit-components';
import { ifDefined } from 'lit/directives/if-defined.js';
import '@beunity/lit-components/components/avatar/element.js';
import translations from './translations.js';

/**
 * List item with avatar and text
 *
 * @prop text - Item text
 * @prop href - Item link
 * @prop picture - Avatar image
 * @prop name - Avatar name,
 */

export default class ListItem5 extends ApplicationElement {
  createRenderRoot() {
    return this;
  }

  /** @internal */
  static translations = translations;

  static properties = {
    href: { type: String },
    remote: { type: String },
    target: { type: String },
    rel: { type: String },
    text: { type: String },
    picture: { type: String },
    name: { type: String },
    deleted: { type: Boolean },
  };

  renderLabel() {
    return html`<ef-label theme="danger">${this.t('deleted')}</ef-label>`;
  }

  render() {
    return html`
      <a
        href="${this.href}"
        data-remote=${ifDefined(this.remote)}
        target=${ifDefined(this.target)}
        rel=${ifDefined(this.rel)}>
        <ef-avatar
          picture=${this.picture}
          name="${this.name}"
          rounded></ef-avatar>
        ${this.deleted && this.renderLabel()}
        <span class="text">${this.text}</span>
      </a>
    `;
  }
}

ListItem5.registerTagName('bu-list-item-5');

customElements.get('bu-list-item-5') ||
  customElements.define('bu-list-item-5', ListItem5);
